export default function validateUrl(url) {
  const regex = /^(http(s)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=[\]]*)$/g;
  if (!regex.test(url)) {
    return false;
  }
  const domainPart = url.split('/')[2];
  return !(domainPart && (domainPart.includes('..') || domainPart.endsWith('-')));
}
